/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import 'react-accessible-accordion/dist/minimal-example.css';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp, getCampaign } from '../../constants/utils';
import { FlowHeader } from '../GoalsFlow/styles';
import ReactFullpage from '@fullpage/react-fullpage';
import FullscreenSection from '../shared/FullscreenSection';
import Graphic from '../landing/Graphic';

import Logo from '../shared/Logo';
import {
  WhiteLogo,
  StyledFooter,
  StyledResults,
  StyledCustomDivision,
  FirstSection,
} from './resultsStyles';
import QuestionSection from './QuestionSection';
import { flexCenter, flexColumn } from '../../constants/styles';
import Title from './Title';
import Text from './Text';
import OptionCard from './OptionCard';
import SimpleQA from './SimpleQA';
import MasterFullpageResult from './MasterFullpageResult';
import ResultByType from './ResultByType';

const StyledLoadingOverlay = styled.div`
  position: absolute;
  z-index: 1000000;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  ${flexCenter}
`;

const StyledLoadingCard = styled.div`
  background-color: white;
  margin: 50px;
  width: 70%;
  height: fit-content;
  padding: 20px;
  border-radius: 8px;
  align-self: flex-start;
`;

class MasterResults extends Component {
  componentDidMount = () => {
    const { resultID } = this.props;
    mp(`[${getCampaign(window.location.href)}] | ${resultID} | Resultado`);
    window.scrollTo(0, 0);
  };

  componentDidUpdate = () => {
    const { resultID } = this.props;
    window.onbeforeunload = () => {
      mp(`[${getCampaign(window.location.href)}] | ${resultID} | Resultados | Se va`);
    };
  };

  render() {
    const { type, children, loading, loadingText } = this.props;

    return (
      <div style={{ overflowAnchor: 'none' }}>
        {loading && (
          <StyledLoadingOverlay>
            <StyledLoadingCard>
              <Title level={2}>{loadingText}</Title>
            </StyledLoadingCard>
          </StyledLoadingOverlay>
        )}
        <StyledResults>
          <ResultByType type={type} {...this.props}>
            {children}
          </ResultByType>
        </StyledResults>
      </div>
    );
  }
}

MasterResults.propTypes = {
  resultID: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  onSlideChange: PropTypes.func,
};

MasterResults.defaultProps = {
  type: 'undefined',
  resultID: 'UndefinedResult',
  loading: false,
  loadingText: 'UndefinedLoadingText',
  onSlideChange: () => {},
};

export default MasterResults;
